
//ie:
//var updatedUrl = new QueryStringBuilder(window.location.href)
//    .upsertQueryString('mode', 'groupingSelection2')
//    .upsertQueryString('selectedGrouping1', valueToSet)
//    .toUpdatedUrl();
export class QueryStringBuilder {
    constructor(url) {
        this.url = url;
    }

    upsertQueryString(key, value) {
        this.url = updateQueryString(this.url, key, value);
        return this;
    }

    removeQueryString(key) {
        this.url = removeQueryString(this.url, key);
        this.url = this.checkForNoQuestStrings(this.url);
        return this;
    }

    toUpdatedUrl() {
        return this.url;
    }

    checkForNoQuestStrings(url) {
        let urlParts = url.split('?');

        //there are no query strings...remove the ?
        if (urlParts.length == 1 || (urlParts.length == 2 && urlParts[1] == '')) {
            return url.replace('?', '');
        }

        return url;
    }
}

export function getQueryStringValueByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function updateQueryString(url, param, paramVal) {
    var newAdditionalURL = "";
    var tempArray = url.split("?");
    var baseURL = tempArray[0];
    var additionalURL = tempArray[1];
    var temp = "";
    if (additionalURL) {
        tempArray = additionalURL.split("&");
        for (var i = 0; i < tempArray.length; i++) {
            if (tempArray[i].split('=')[0] != param) {
                newAdditionalURL += temp + tempArray[i];
                temp = "&";
            }
        }
    }

    var rows_txt = temp + "" + param + "=" + paramVal;
    return baseURL + "?" + newAdditionalURL + rows_txt;
}

//parameters is []
export function removeQueryStrings(url, parameters) {
 
    let tempUrl = url;

    for (var i = 0; i < parameters.length; i++) {
        tempUrl = removeQueryString(tempUrl, parameters[i]);
    }

    return tempUrl;
}

export function removeQueryString(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {

        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        url = urlparts[0] + '?' + pars.join('&');
        return url;
    } else {
        return url;
    }
}